var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBarkingAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81146 20.0246C4.43623 19.9272 4.04193 20.1263 3.88369 20.493C3.73746 20.8824 3.91924 21.3355 4.31849 21.4781L21.2446 27.8753C21.315 27.8971 21.3974 27.9415 21.4558 27.9407C22.4758 28.2001 23.5299 27.5818 23.7727 26.5988C24.0387 25.6041 23.4047 24.5761 22.3966 24.3394L4.81146 20.0246Z",
    fill: "url(#paint0_linear_1243_24424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45413 14.8125C3.10373 14.8397 2.51691 15.3034 2.50023 15.9307C2.48354 16.558 3.07036 17.1034 3.45413 17.1307L27.9554 18.6667C29.2282 18.6667 30.5487 17.4307 30.4986 15.8761C30.4486 14.3216 29.2282 13.3333 27.9554 13.3333L3.45413 14.8125Z",
    fill: "url(#paint1_linear_1243_24424)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3205 8.05419C17.4302 8.0073 17.5659 7.971 17.686 7.89792C18.6889 7.36059 19.0788 6.0867 18.5083 5.09315C17.9743 4.08397 16.7083 3.69168 15.7209 4.26578L4.27077 10.4636C3.92077 10.6567 3.7526 11.0759 3.87134 11.4594C4.02115 11.9164 4.49491 12.1697 4.92303 12.0084L17.3205 8.05419Z",
    fill: "url(#paint2_linear_1243_24424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1243_24424",
    x1: 7.40492,
    y1: 20.5,
    x2: 12.4098,
    y2: 32.5015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#804D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1243_24424",
    x1: 7.5,
    y1: 13.6667,
    x2: 9.2944,
    y2: 22.7028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#804D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1243_24424",
    x1: 6.50116,
    y1: 4.50357,
    x2: 12.5631,
    y2: 15.2843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#804D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623B01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarkingAlt);
export default __webpack_public_path__ + "static/media/icon_barking_alt.79c61b4369e752f7ee66cdeae2547b6f.svg";
export { ForwardRef as ReactComponent };